import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ expeditedUserNameError: string }>;

export const DispatchExpeditedUserNameError: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/ExpeditedUserNameError",
        expeditedUserNameError: props.parameter.expeditedUserNameError,
    });
};

export const chain = [DispatchExpeditedUserNameError];

const setExpeditedUserNameError = createHandlerChainRunner(chain, "setExpeditedUserNameError");
export default setExpeditedUserNameError;
